import { ApplicationSourceIssueState } from './application-source-issue-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import { Action, updateResourceByParam } from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState: ApplicationSourceIssueState = {
  applicationSourceIssuesById: {},
  applicationSourceIssuesStateByOrgId: {},
};

export const applicationSourceIssueReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_APPLICATION_SOURCE_ISSUES'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(state, 'applicationSourceIssues', 'orgId', orgId, true);
    }
    case SUCCESS('LOAD_APPLICATION_SOURCE_ISSUES'): {
      const {
        args: { orgId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'applicationSourceIssues',
        'orgId',
        orgId,
        false,
        convertArrayToMap(data, (d: ApplicationSourceIssue) => String(d.applicationSourceIssueId)),
      );
    }
    case FAILURE('LOAD_APPLICATION_SOURCE_ISSUES'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(state, 'applicationSourceIssues', 'orgId', orgId, false);
    }
    case STARTING('RESOLVE_APPLICATION_SOURCE_ISSUE'): {
      const { applicationSourceIssueId } = action.payload.args;
      return updateResourceByParam(
        state,
        'applicationSourceIssues',
        'applicationSourceIssueId',
        applicationSourceIssueId,
        true,
      );
    }
    case SUCCESS('RESOLVE_APPLICATION_SOURCE_ISSUE'): {
      const {
        args: { applicationSourceIssueId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'applicationSourceIssues',
        'applicationSourceIssueId',
        applicationSourceIssueId,
        false,
        { [applicationSourceIssueId]: data },
      );
    }
    case FAILURE('RESOLVE_APPLICATION_SOURCE_ISSUE'): {
      const { applicationSourceIssueId } = action.payload.args;
      return updateResourceByParam(
        state,
        'applicationSourceIssues',
        'applicationSourceIssueId',
        applicationSourceIssueId,
        false,
      );
    }
    default: {
      return state;
    }
  }
};
